import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router';
import { Icon } from 'react-fast-ui';

export const NAVLINK_CX = 'nav-link futura-pt-md';

const NAV_STYLE = {
  textDecoration: 'none',
  boxSizing: 'border-box',
  fontSize: 15,
};


export default class NavLink extends Component {
  static propTypes = {
    activePaths: PropTypes.array,
    linkClasses: PropTypes.string,
    href: PropTypes.string,
    icon: PropTypes.string,
    page: PropTypes.string,
    path: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  };

  static defaultProps = {
    target: '_blank'
  };

  getClasses() {
    const { className, linkClasses } = this.props;

    return cx(
      NAVLINK_CX,
      className,
      linkClasses,
      { 'active-item': this.isSelected() },
    );
  }

  isSelected = () => {
    if (!this.props.path) return false;
    if (typeof this.props.path === 'string') {
      return this.props.page === this.props.path;
    }

    return this.props.page === this.props.path.pathname;
  };


  render() {
    const { children, href, icon, path, id, onClick, target, style } = this.props;

    if (href) {
      return (
        <a
          onClick={onClick}
          id={id}
          className={this.getClasses()}
          href={href}
          style={{ ...NAV_STYLE, ...style }}
          target={target}>
          {icon ? <Icon className='mg-right-sm' name={icon} size='md'/> : null}
          {children}
        </a>
      );
    } else {
      return (
        <Link
          id={id}
          to={path}
          className={this.getClasses()}
          style={NAV_STYLE}>
          {icon ? <Icon className='mg-right-sm' name={icon} size='md'/> : null}
          {children}
        </Link>
      );
    }
  }
}